module.exports = __webpack_public_path__ + "img/p-42.340b0701.jpg";